/** "1 job" / "3 jobs" */
export const pluralise = (n: number, noun: string): string =>
  `${n} ${noun}${n === 1 ? '' : 's'}`;
